var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcErrorQuestionGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 11H7.66667V9.66667H6.33333V11ZM7 0.333332C3.32 0.333332 0.333332 3.32 0.333332 7C0.333332 10.68 3.32 13.6667 7 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7C13.6667 3.32 10.68 0.333332 7 0.333332ZM7 12.3333C4.06 12.3333 1.66667 9.94 1.66667 7C1.66667 4.06 4.06 1.66667 7 1.66667C9.94 1.66667 12.3333 4.06 12.3333 7C12.3333 9.94 9.94 12.3333 7 12.3333ZM7 3C5.52667 3 4.33333 4.19333 4.33333 5.66667H5.66667C5.66667 4.93333 6.26667 4.33333 7 4.33333C7.73333 4.33333 8.33333 4.93333 8.33333 5.66667C8.33333 7 6.33333 6.83333 6.33333 9H7.66667C7.66667 7.5 9.66667 7.33333 9.66667 5.66667C9.66667 4.19333 8.47333 3 7 3Z",
    fill: "#39E8BE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcErrorQuestionGreen);
export default __webpack_public_path__ + "static/media/ic_error_question_green.03ebc5bc86955b0b3fda84acb0a5b655.svg";
export { ForwardRef as ReactComponent };